import { render, staticRenderFns } from "./TeamsPath.vue?vue&type=template&id=4c26279a&"
import script from "./TeamsPath.vue?vue&type=script&lang=js&"
export * from "./TeamsPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports